import PropTypes from 'prop-types';

import { FIELD_NAMES } from '../address/address-fields/constants';

export const ShipToPropType = PropTypes.shape({
  [FIELD_NAMES.CITY]: PropTypes.string,
  [FIELD_NAMES.COMPANY]: PropTypes.string,
  [FIELD_NAMES.COUNTRY_CODE]: PropTypes.string,
  [FIELD_NAMES.LINE1]: PropTypes.string,
  [FIELD_NAMES.LINE2]: PropTypes.string,
  [FIELD_NAMES.LINE3]: PropTypes.string,
  [FIELD_NAMES.NAME]: PropTypes.string,
  [FIELD_NAMES.PHONE]: PropTypes.string,
  [FIELD_NAMES.POSTAL_CODE]: PropTypes.string,
  [FIELD_NAMES.STATE]: PropTypes.string,
  [FIELD_NAMES.RESIDENTIAL_INDICATOR]: PropTypes.string, // TODO: DAT - define in enum and reference here
  verificationStatus: PropTypes.string, // TODO: DAT - define in enum and reference here
  verificationMessage: PropTypes.string,
  verificationUtc: PropTypes.string,
  lockAddress: PropTypes.bool,
});

/**
 * @typedef {object} ShipToPropType
 * @property {string} city
 * @property {string} company
 * @property {string} countryCode
 * @property {string} line1
 * @property {string} line2
 * @property {string} line3
 * @property {string} name
 * @property {string} phone
 * @property {string} postalCode
 * @property {string} state
 * @property {string} residentialIndicator
 * @property {string} verificationStatus
 * @property {string} verificationMessage
 * @property {string} verificationUtc
 * @property {boolean} lockAddress
 */
